import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import './Dojo.css';
import { DojoRepository } from '../data/DojoRepository';

class Gaspe extends Component {
  render() {
    return (
        <div class="container page-content">
            <div id="dojoHeader">
                <img id="ShotokanLogo" alt="Logo du karaté Shotokan" src="/images/logos/Shotokan.png" />
            </div>
            <article id="dojoContent">
                <section id="dojoDescription"> 
                    <h1>{DojoRepository.GASPE.name}</h1>
                    <p>BudoKan Gaspé est un lieu où se pratique 5 Arts Martiaux différents. Le karaté, le kobudo, le Iaïdo, le Kyudo et le Yabusame. Le karaté de style shotokan est pourvu d’un volet sportif axé vers la compétition . Le kobudo est de style Ryukyu. Le iaïdo est de style Eishin Ryu. Le style de Kyudo est en voie de réalisation alors que le Yabusame est unique au Canada.</p>
                    <p>Il n’y a aucun frais à pratiquer au BudoKan de Gaspé. L’horaire est changeant au besoin des pratiquants. Les nouveaux pratiquants sont sur invitations seulement. Il y a présentement une quinzaine de pratiquants dont quelques championnes membres des équipes du Québec et du Canada en combat WKF et ISKF.</p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoTeam"> 
                    <h1>L'équipe</h1>
                    <p>
                        <strong>Instructeurs</strong><br />
                        {DojoRepository.GASPE.contacts[0].fullName}<br />
                        {DojoRepository.GASPE.contacts[1].fullName}<br />
                        {DojoRepository.GASPE.contacts[2].fullName}
                    </p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoSchedule"> 
                    <h1>Horaire</h1>
                    
                    <p>Nous vous invitons à consulter le fichier suivant pour obtenir toute l'information concernant notre offre de cours.</p>
                    <p><a href="/pdf/dojo/Horaire-Budokan-Gaspe.pdf">Horaire complet</a></p>

                </section>
                <p>&nbsp;</p>

                <section id="dojoContacts"> 
                    <h1>Pour nous joindre</h1>
                    <p>
                        <strong>{DojoRepository.GASPE.name}</strong><br />
                        {DojoRepository.GASPE.addresses[0].line1}<br />
                        {DojoRepository.GASPE.addresses[0].city}<br />
                        {DojoRepository.GASPE.addresses[0].postalCode}<br />
                        <a href={DojoRepository.GASPE.addresses[0].googleMaps} target="_blank" rel="noopener noreferrer" title={DojoRepository.GASPE.name}>Google Maps</a>
                    </p>
                    <p>
                        <strong>Instructeur</strong><br />
                        {DojoRepository.GASPE.contacts[0].fullName}<br />
                        {DojoRepository.GASPE.contacts[0].phone1}<br />
                        <span class="link-like">{DojoRepository.GASPE.contacts[0].email1}</span><br />
                    </p>
                </section> 
                <p>&nbsp;</p>
                
                <section id="dojo-map">
                    <Map
                        google={this.props.google}
                        initialCenter={DojoRepository.GASPE.geo}>
                        <Marker position={DojoRepository.GASPE.geo} />
                    </Map>
                </section> 
            </article>
            <Link class="returnToDojoRepository" to="/dojo">Retour au repertoire des Dojos</Link>
        </div>
    );
  }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(Gaspe)



// WEBPACK FOOTER //
// ./src/pages/dojo/Gaspe.js